import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

export default function ManageUsersByMarketer({
  openItem = null,
  activeItem = null,
}) {
  return (
    <li
      className={`nav-item has-treeview 
      ${sidebarHelper.checkOpenItem(openItem, "users-marketer")} `}
    >
      <a
        href="# "
        className={`nav-link  
      ${sidebarHelper.checkActiveItem(openItem, "users-marketer")} `}
      >
        <i className="nav-icon fa hl-user"></i>
        <p>
          مدیریت کاربران
          <i className="right fa fa-angle-left"></i>
        </p>
      </a>

      <ul className="nav nav-treeview">
        <li className="nav-item">
          <Link
            to="/marketer/all-user-registered"
            className={`nav-link  d-flex
          ${sidebarHelper.checkActiveItem(activeItem, "all-user-marketer")} `}
          >
            <i className="nav-icon fa fa-user"></i>
            <p> لیست کاربر</p>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to="/marketer/add-user"
            className={`nav-link  d-flex
          ${sidebarHelper.checkActiveItem(
            activeItem,
            "add-user-by-marketer"
          )} `}
          >
            <i className="nav-icon fa fa-user"></i>
            <p>اضافه کردن کاربر</p>
          </Link>
        </li>
      </ul>
    </li>
  );
}
